import { fromSpecific, scope, TypedNode } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import type { AnyExpressionSpecific, MustacheNode } from '../Mustache'
import type { VariableModel } from './ViewModel'
import type { TypedSpecificLike } from '@rehaje/core'

export interface VariableSpecific extends TypedSpecificLike {
  /**
   * 变量的默认值
   */
  defaultValue?: AnyExpressionSpecific | unknown
  /**
   * 变量的备注，用于描述变量用途
   */
  description?: string
  /**
   * 变量标题
   */
  title?: string
  type: 'Variable'
}

@scope({
  variables() {
    return [
      {
        description: this.description,
        get: () => {
          return this.getExposedViewModel<VariableModel>()
        },
        group: 'Variable',
        name: () => {
          return this.id
        },
        title: this.title,
        type: 'Block'
      }
    ]
  }
})
export class VariableNode extends TypedNode {
  /*
   * 变量的默认值
   */
  @fromSpecific()
  @reactive()
  defaultValue?: MustacheNode | unknown

  /**
   * 变量的备注，用于描述变量用途
   */
  @fromSpecific()
  @reactive()
  description?: string

  /**
   * 变量标题
   */
  @fromSpecific()
  @reactive()
  title?: string

  override fromSnapshot(root: TypedNode): void {
    if (root instanceof TypedNode && root.type === 'Page') {
      root.append(this, ['variables'])
    }
  }
}

declare global {
  export interface RehajeSpecifics {
    Variable: VariableSpecific
  }
  export interface RehajeTypedNodes {
    Variable: VariableNode
  }
}
